import { NgModule } from '@angular/core';
import { ConfigStateModule } from './state/config-state.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CidInterceptor, LanguageInterceptor, LodgxToRoomexFallbackInterceptor, RetryInterceptor } from './interceptors';
import { RequestIdInterceptor } from './interceptors/request-id-interceptor';

@NgModule({
  imports: [ConfigStateModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RetryInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CidInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestIdInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LodgxToRoomexFallbackInterceptor,
      multi: true,
    },
  ],
})
export class ClientsiteSharedConfigDataAccessModule {}
